import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Label = _resolveComponent("Label")
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Label, {
      error: _ctx.error,
      labelId: _ctx.labelId,
      label: _ctx.label
    }, null, 8, ["error", "labelId", "label"]),
    _createVNode("div", {
      class: ["border-solid border px-2 py-2 mt-2 rounded-md flex items-center justify-between outline-none transform relative", {
				'bg-gray-200 border-gray-300 cursor-text text-gray-500': _ctx.isDisabled,
				'border-gray-300 hover:border-gray-600 bg-white cursor-pointer text-gray-600 hover:text-gray-700 focus:border-primary transition duration-300':
					!_ctx.error && !_ctx.isDisabled,
				'border-red-600 bg-white text-red-600': _ctx.error && !_ctx.isDisabled,
				'z-50': _ctx.selected,
				'z-0': !_ctx.selected,
			}],
      tabindex: "0",
      onBlur: _cache[1] || (_cache[1] = $event => (_ctx.blurEvent())),
      onClick: _cache[2] || (_cache[2] = $event => (_ctx.handleClick()))
    }, [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.getPlaceholder), 1),
      _createVNode(_component_ChevronDownIcon, {
        class: ["transform transition duration-300 h-6 w-6", {
					'rotate-180': _ctx.selected,
					'rotate-0': !_ctx.selected,
				}]
      }, null, 8, ["class"]),
      _createVNode("div", {
        class: ["bg-white border border-gray-300 shadow-sm absolute transform top-0 left-0 rounded w-full transition ease-out duration-300 max-h-48 overflow-y-auto", {
					'translate-y-12 opacity-100': _ctx.selected,
					'translate-y-0 opacity-0': !_ctx.selected,
				}],
        ref: "dropDownItems"
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "hover:bg-gray-200 p-2",
            onClick: $event => (_ctx.setValue(item[_ctx.itemValue]))
          }, _toDisplayString(item[_ctx.itemLabel]), 9, ["onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2)
    ], 34)
  ]))
}